// import NewsDetail from "components/newsDetail";
// import { getSession } from "next-auth/react";

import { getAuthorizedApi } from "api/apiInstance";
import { baseUrl, baseUrlV2 } from "api/constants";

import { Urls404 } from "constants/Urls404";

// import { getCtxPayload } from "utils/loggerHelper";
// import { getCtxPayload } from "utils/loggerHelper";
import VideoPage from "../../../../components/updatedNewsDetail/videoPage";
// const VideoPage = dynamic(()=>import("../../../../components/updatedNewsDetail/VideoPage"),{ssr:true})
// const Detailpage = dynamic(() =>
//   import("../../../../components/liveblog/detailPage")
// );

export default function News(props) {

  return <VideoPage {...props} />
}

export async function getServerSideProps(ctx) {
  const { slug } = ctx.params;
  const prevUrl = ctx?.req?.headers?.referer || "/";
  const lallantop = JSON.parse(ctx.req?.cookies?.lallantop || "{}");
  const httpClient = await getAuthorizedApi(lallantop.encryptedToken);
  const categoryName = "election";
  const dataProps = {};

  // Check if slug is in Urls404
  if (Urls404.includes(slug)) {
    return { notFound: true };
  }

  // Handle case when slug is missing
  if (!slug) {
    try {
      const { data } = await httpClient.get(`${baseUrl}/column/detail?_id=${postId}`);
      dataProps.postData = data?.result;
    } catch (error) {
      console.error("Error fetching column detail", error);
    }
  } else {
    try {
      const { data } = await httpClient.get(`${baseUrlV2}/web/postDetailsByCategory/election/${encodeURIComponent(slug)}`);
      dataProps.postData = data?.result || null;

      if (!dataProps.postData) {
        return { redirect: { destination: `/all/${categoryName}`, permanent: true } };
      }

      if (dataProps.postData?.redirectUrl) {
        const pathname = dataProps.postData.permalink.split(".com");
        return { redirect: { destination: pathname.length > 1 ? pathname[1] : pathname[0], permanent: false } };
      }

      // Handle live blog case
      if (dataProps.postData?.type === "liveblog") {
        const [data1, data2, trendingData] = await Promise.all([
          httpClient.get(`${process.env.NEXT_PUBLIC_LIVE_BLOG_BASE_URL}/liveBlog/${slug}`).catch(() => { return null }),
          httpClient.get(`${process.env.NEXT_PUBLIC_LIVE_BLOG_BASE_URL}/events/listByBlogSlug?blogSlug=${slug}&pageNumber=1&pageSize=50`).catch(() => { return null }),
          httpClient.get(`${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/post/trending?limit=6&skip=1&type=audio,video,text`).catch(() => { return null }),
        ]);

        let mergedString = "";
        if (data2?.data?.result?.entities?.length) {
          mergedString = data2.data.result.entities.slice(0, 10).map(e => `${e.title} ${e.articlePlainText}`).join(" ");
        }

        return {
          props: {
            ...dataProps,
            detailsData: data1?.data?.result || null,
            eventsData: data2?.data?.result || null,
            isLiveBlog: true,
            trendingData: trendingData?.data?.result || null,
            mergedString
          },
        };
      }
    } catch (error) {
      console.error("Error fetching post details", error);
    }
  }

  // Fetch other necessary data concurrently
  let [trendingData, articlePageBanners, electionTopicData, articleTopVideos] = await Promise.allSettled([
    httpClient.get(`${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/post/trending?limit=6&skip=1&type=audio,video,text`).catch(() => { return null }),
    httpClient.get(`${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/banner/all?source=WEB&category=article-detail-page`).catch(() => { return null }),
    httpClient.get(`${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/topicItem/getContentsBySlugAndType?limit=6&skip=1&slug=chunav-yatra-2024&type=video`).catch(() => { return null }),
    httpClient.get(`${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/web/homePageArticleWidget?limit=6&skip=1`).catch(() => { return null })
  ]);

  electionTopicData = electionTopicData.status === "fulfilled" && electionTopicData.value?.data?.result?.entities
    ? electionTopicData.value.data.result.entities
    : [];

  let homePageVideos = articleTopVideos.status === "fulfilled" && articleTopVideos.value?.data?.result?.entities
    ? articleTopVideos.value.data.result
    : [];

  try {
    ctx.res.setHeader("Cache-Control", `max-age=120, stale-if-error=86400`);
  } catch (error) {
    console.error("Cache error", error);
  }

  return {
    props: {
      ...dataProps,
      prevUrl,
      trendingData: trendingData?.data?.result || [],
      isLiveBlog: false,
      articlePageBanners: articlePageBanners?.data?.result || [],
      electionTopicData,
      homePageVideos
    },
  };
}
